/***
 * 全局事件处理类
 * g2.carto.Map事件代理
 * @author yangxx
 */
/**
 * 事件委托类
 * @module AppEvent
 */
define([
    '../g2'
],function (
    g2
) {

    var arrySlice = Array.prototype.slice;

    /**
     * 构造方法
     * @constructor
     * @classdesc 事件委托类
     * @alias G.misc.AppEvent
     * @param options {Object} 必填，实例化参数
     * @param options.id {String} 必填，唯一标识
     * @param options.map {G.Map} 必填，地图对象
     * @returns {Object} 实例化的对象
     */
    var _appEvent = function (options) {
        this._$handlers = {};
        if (options) {
            this.delegateMapEvents(options.map);
        }
    };

    _appEvent.prototype = {

        constructor: _appEvent,

        /**
         * 单次触发绑定，on后销毁
         * @method
         * @private
         * @param {string} event 事件名
         * @param {Function} handler 响应函数
         * @param {Object} context
         */
        once: function (event, handler, context) {
            if (!this._$handlers) {
                this._$handlers = {};
            }
            var _h = this._$handlers;

            if (!handler || !event) {
                return this;
            }

            if (!_h[event]) {
                _h[event] = [];
            }

            for (var i = 0; i < _h[event].length; i++) {
                if (_h[event][i].h === handler) {
                    return this;
                }
            }

            _h[event].push({
                h: handler,
                one: true,
                ctx: context || this
            });

            return this;
        },

        /**
         * 绑定事件
         * @method
         * @private
         * @param {string} event 事件名
         * @param {Function} handler 事件处理函数
         * @param {Object} [context]
         */
        addEventListener: function (event, handler, context) {
            if (!this._$handlers) {
                this._$handlers = {};
            }
            var _h = this._$handlers;

            if (!handler || !event) {
                return this;
            }

            if (!_h[event]) {
                _h[event] = [];
            }

            for (var i = 0; i < _h[event].length; i++) {
                if (_h[event][i].h === handler) {
                    return this;
                }
            }

            _h[event].push({
                h: handler,
                one: false,
                ctx: context || this
            });

            return this;
        },

        /**
         * 是否绑定了事件
         * @method
         * @private
         * @param  {string}  event
         * @return {boolean}
         */
        listens: function (event, fn) {
            if (!this._$handlers) {
                this._$handlers = {}
            }
            var _h = this._$handlers;
            if (!fn) {
                return !!(_h[event] && _h[event].length);
            }
            else {
                for (var index = 0; index < _h[event].length; index++) {
                    if (_h[event][index].h == fn)
                        return true;
                }
                return false;
            }


        },

        /**
         * 解绑事件
         * @method
         * @private
         * @param {string} event 事件名
         * @param {Function} [handler] 事件处理函数
         */
        removeEventListener: function (event, handler) {
            if (!this._$handlers) {
                this._$handlers = {};
            }
            var _h = this._$handlers;

            if (!event) {
                this._$handlers = {};
                return this;
            }

            if (handler) {
                if (_h[event]) {
                    var newList = [];
                    for (var i = 0, l = _h[event].length; i < l; i++) {
                        if (_h[event][i]['h'] != handler) {
                            newList.push(_h[event][i]);
                        }
                    }
                    _h[event] = newList;
                }

                if (_h[event] && _h[event].length === 0) {
                    delete _h[event];
                }
            }
            else {
                delete _h[event];
            }

            return this;
        },

        /**
         * 事件分发
         * @method
         * @private
         * @param {string} type 事件类型
         */
        fireEvent: function (type) {
            if (!this._$handlers) {
                this._$handlers = {};
            }
            //执行的返回值
            var results=[];
            if (this._$handlers[type]) {
                var args = arguments;
                var argLen = args.length;

                if (argLen > 3) {
                    args = arrySlice.call(args, 1);
                }

                var _h = this._$handlers[type];
                var len = _h.length;
                for (var i = 0; i < len;) {
                    var result=null;
                    // Optimize advise from backbone
                    switch (argLen) {
                        case 1:
                            result=_h[i]['h'].call(_h[i]['ctx']);
                            break;
                        case 2:
                            result=_h[i]['h'].call(_h[i]['ctx'], args[1]);
                            break;
                        case 3:
                            result=_h[i]['h'].call(_h[i]['ctx'], args[1], args[2]);
                            break;
                        default:
                            // have more than 2 given arguments
                            result=_h[i]['h'].apply(_h[i]['ctx'], args);
                            break;
                    }
                    results.push(result);
                    if (_h[i]['one']) {
                        _h.splice(i, 1);
                        len--;
                    }
                    else {
                        i++;
                    }
                }
            }
            //返回所有回调的返回值，不返回this，不能使用链式操作
            return results;
        },

        /**
         * 带有context的事件分发, 最后一个参数是事件回调的context
         * @method
         * @private
         * @param {string} type 事件类型
         */
        fireWithContext: function (type) {
            if (!this._$handlers) {
                this._$handlers = {};
            }
            if (this._$handlers[type]) {
                var args = arguments;
                var argLen = args.length;

                if (argLen > 4) {
                    args = arrySlice.call(args, 1, args.length - 1);
                }
                var ctx = args[args.length - 1];

                var _h = this._$handlers[type];
                var len = _h.length;
                for (var i = 0; i < len;) {
                    // Optimize advise from backbone
                    switch (argLen) {
                        case 1:
                            _h[i]['h'].call(ctx);
                            break;
                        case 2:
                            _h[i]['h'].call(ctx, args[1]);
                            break;
                        case 3:
                            _h[i]['h'].call(ctx, args[1], args[2]);
                            break;
                        default:
                            // have more than 2 given arguments
                            _h[i]['h'].apply(ctx, args);
                            break;
                    }

                    if (_h[i]['one']) {
                        _h.splice(i, 1);
                        len--;
                    }
                    else {
                        i++;
                    }
                }
            }

            return this;
        }
    };
    /**
     * 添加监听
     * @method
     * @param types {String}  必填，事件类型字符串，多个逗号分隔；
     * @param handler {Function} 必填，回调函数
     * @param context {Object} 必填，监听上下文对象
     *
     */
    _appEvent.prototype.on = _appEvent.prototype.addEventListener;
    /**
     * 移除监听
     * @method
     * @param types {String}  必填，事件类型字符串，多个逗号分隔；
     * @param context {Object} 必填，监听上下文对象
     *
     */
    _appEvent.prototype.off = _appEvent.prototype.removeEventListener;
    /**
     * 分发事件（同fireEvent)
     * @method
     * @param type {String}  必填，事件类型字符串；
     * @param data {Object} 必填，传输的数据；
     *
     */
    _appEvent.prototype.fire = _appEvent.prototype.fireEvent;

    /***
     * 地图事件代理
     */
    (function () {
        /**
         * 枚举所有地图事件-{{click: {args: [*], var: string, indexKey: string}, dblclick: boolean, mousemove: boolean, mousedown: boolean, mouseup: boolean, extentchanged: boolean, resize: boolean, resolutionchanged: boolean}}
         * @type {Object}
         */
        var events = {
            'click': {
                args: ['button', 'shift', 'screenX', 'screenY', 'mapX', 'mapY', 'handle'],
                var: 'clickDelegates_',
                api: 'MapClick'
            },
            'dblclick': {
                args: ['screenX', 'screenY', 'mapX', 'mapY'],
                var: 'dblClickDelegates_',
                api: 'MapDblClick'
            },
            'mousemove': {
                args: ['button', 'shift', 'screenX', 'screenY', 'mapX', 'mapY', 'handle'],
                var: 'mouseMoveDelegates_',
                api: 'MapMouseMove'
            },
            'mousedown': {
                args: ['button', 'shift', 'screenX', 'screenY', 'mapX', 'mapY', 'handle'],
                var: 'mouseDownDelegates_',
                api: 'MapMouseDown'
            },
            'mouseup': {
                args: ['button', 'shift', 'screenX', 'screenY', 'mapX', 'mapY', 'handle'],
                var: 'mouseUpDelegates_',
                api: 'MapMouseUp'
            },
            'extentchanged': {
                args: ['left', 'top', 'right', 'bottom'],
                var: 'extentChangedDelegates_',
                api: 'MapExtentChange'
            },
            'resize': {
                args: ['newSize', 'oldSize'],
                var: 'resizeDelegates_',
                api: 'MapResize'
            },
            'resolutionchanged': {
                args: ['newResolution', 'oldResolution', 'level'],
                var: 'resolutionChangedDelegates_',
                api: 'MapResolutionChange'
            }
        };
        /**
         * 代理地图事件,初始化时调用一次.
         * @method
         * @private
         * @param map {g2.carto.Map} 地图对象
         */
        _appEvent.prototype.delegateMapEvents = function (map) {
            if (map instanceof g2.carto.Map) {
                var self = this;
                var g2mapListeners = {};
                _initialize.call(self);
                //监听地图事件
                for (var event in events) {
                    var obj = events[event];
                    var listener = getOnFun(event);
                    map.on(event, listener);
                    g2mapListeners[event] = listener;
                }
                //存储对g2map的监听回调
                this._g2mapListeners = g2mapListeners;
            } else {
                throw(new Error('map对象必须为g2.carto.Map类型！'))
            }
            /**
             * 初始化监听
             * @private
             */
            function _initialize() {
                for (var event in events) {
                    var obj = events[event];
                    this[obj['var']] = [];
                    this[obj['var']]['_' + event + '_index'] = 0;
                }
            }

            /**
             * 监听头tsgis map
             * @param event
             * @returns {fun}
             */
            function getOnFun(event) {
                var fun = function () {
                    var args = [];
                    for (var k = 0, len = arguments.length; k < len; k++) {
                        args.push(arguments[k]);
                    }
                    _listener.call(self, arguments.callee._event, args);
                };
                fun._event = event;
                return fun;
            }

            /**
             * 监听处理
             * @param event
             * @param args
             * @private
             */
            function _listener(event, args) {
                var obj = events[event];
                if (obj) {
                    var listeners = this[obj['var']],
                        argsKeys = obj['args'];
                    //调用参数
                    var argss = {};
                    for (var i = 0, len = argsKeys.length; i < len; i++) {
                        var argsKey = argsKeys[i];
                        argss[argsKey] = args[i];
                    }
                    /**
                     * 调用监听
                     */
                    if (Object.prototype.toString.call(listeners) == '[object Array]') {
                        for (var i = 0, len = listeners.length; i < len; i++) {
                            var linstenObj = listeners[i];
                            if (linstenObj) {
                                try {
                                    linstenObj.callback.call(linstenObj.context, argss);
                                } catch (e) {
                                    console.error(e)
                                }
                            }
                        }
                    }
                }
            }
        };
        /**
         * 取消代理地图事件
         * @method
         * @private
         * @param map
         */
        _appEvent.prototype.unDelegateMapEvents = function (map) {
            if (map instanceof g2.carto.Map) {
                if (this._g2mapListeners) {
                    for (var event in this._g2mapListeners) {
                        try {
                            map.un(event, this._g2mapListeners[event]);
                        } catch (e) {
                        }
                    }
                }
            }
        }
        /**
         * 添加监听
         * @method
         * @private
         * @param event {String} 事件名
         * @param callback {Function}
         * @param context {Object}
         * @returns {Boolean} true=success/false=failure
         * @private
         */
        _appEvent.prototype._on = function (event, callback, context) {
            var flag = false;
            try {
                var obj = events[event];
                if (obj) {
                    var listeners = this[obj['var']],
                        indexKey = '_' + event + '_index',
                        index = listeners[indexKey];
                    listeners[index] = {
                        context: context,
                        callback: callback
                    }
                    listeners[indexKey] = index + 1;
                    flag = true;
                }
            } catch (e) {
                console.error(e.message);
            }
            return flag;
        };

        /**
         * 判断是否是地图事件
         * @method
         * @private
         * @param event
         * @returns {boolean}
         */
        _appEvent.prototype.isMapEvent = function (event) {
            return events.hasOwnProperty(event);
        }
        /**
         * 取消监听
         * @method
         * @private
         * @param event {String} 事件名
         * @param callback {Function}
         * @param context {Object}
         * @returns {Boolean} true=success/false=failure
         * @private
         */
        _appEvent.prototype._off = function (event, callback, context) {
            var flag = false;
            var callbackFlag = Object.prototype.toString.call(callback) == '[object Function]',
                contextFlag = !!context;
            try {
                var obj = events[event];
                var listeners = this[obj['var']];
                for (var i = listeners.length-1; i >=0; i--) {
                    var listenObj = listeners[i];
                    if (listenObj) {
                        if (_assertEqual(listenObj)) {
                            listeners[i] = undefined;
                            listeners.splice(i,1);
                            flag = true;
                        }
                    }
                }
            } catch (e) {
                console.error(e.message);
            }
            /**
             * 判断是否相等
             * @param obj
             * @private
             */
            function _assertEqual(obj) {
                obj = obj || {};
                if (callbackFlag && contextFlag) {
                    return obj.callback === callback
                        && obj.context === context;
                } else if (callbackFlag) {
                    return obj.callback === callback;
                } else if(contextFlag){
                    return obj.context === context;
                }else{
                    return false;
                }
            }

            return flag;
        }
    })();
    //

    return _appEvent;
});
